import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {
    public transform(value: string) {
        return value ? this.capitalize(value) : value;
    }

    private capitalize(value: string) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/capitalize.pipe.ts